import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import SiloBustingWidgetBody from './body';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>,
    chartData: <object>
  }
}
*/

export const exportEventName = "siloBustingChartExport";

const SiloBusting = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "grid-item-span-full-width" });
  const configBuilder = (_state) => {
    return {
      remoteOptions: getRemoteConfigs(url, SiloBustingWidgetBody)
    };
  };

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { exportEventName });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      loadersRowCount= {2}
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default SiloBusting;
